<template>
<div class="loading_component">
    <div class="skeleton">
        <skeleton v-for="(item, i) in 1"
            :key="i" />
    </div>
    <div class="loading">
        <loading />
    </div>
</div>
</template>

<script>
import Loading from '@/components/common/is-loading'
import Skeleton from '@/components/common/skeleton'
import {horizontalScreen} from '../../assets/js/horizontal';
export default {
  name: 'loading-page',
  components: {Loading, Skeleton},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  beforeCreate() {},
  created() {
    
  },
  beforeMount() {},
  mounted() {
    let flag = this.$route.query.videoFlag;
    if(flag == 1) {
         horizontalScreen();
    }
    setTimeout(() => {
        if(flag == 1) {
            this.$router.replace('/happySpaceVideo')
        }else {
            this.$router.replace('/video')
        }
    }, 500);
},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang="scss">
    .loading_component {
        overflow: hidden;
        height: 100%;
        width: 100%;
        .skeleton {
            margin-top: 58px;
        }
        .loading {
            position: absolute;
            overflow: hidden;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
        }
        
    }
</style>
